module.exports = __webpack_public_path__ + "img/6.d3dd7a24.png";